import React from 'react';
import rawMarkup from '../../util/rawMarkup';


let scriptContent = `
    function OptanonWrapper() {
    	{window.dataLayer.push({event:'OneTrustGroupsUpdated'})} 
    	
    	let consentUser = 0;
    	
    	var consentFromCookie = {{Cookie - Actual Cookie Consent}};
		var consentFromDataLayer = {{dlv - Active Consent Groups}};
		if (consentFromDataLayer != undefined && consentFromCookie == undefined) {
		    if (consentFromDataLayer.indexOf(",3,") >= 0) {
		    	consentUser =3; // functional cookies allowed
		      
		    } 
		    if (consentFromDataLayer.indexOf(",2,") >= 0) {
		    	consentUser =2; // functional cookies allowed
		      
		    } 
		    if (consentFromDataLayer.indexOf(",4,") >= 0) {
		    	consentUser =4; // functional cookies allowed
		      
		    } 
		}
     
    	window.onetrustcookies = {
	    	consentUser: consentUser,

		}
		document.getElementById("consentUser").innerHTML = consentUser;
		console.log("consentUser-script: " + window.onetrustcookies.consentUser);
	}
`;


const OneTrustScript = () => <script type="text/javascript" dangerouslySetInnerHTML={rawMarkup(scriptContent)} />;
export default OneTrustScript;



// WEBPACK FOOTER //
// ./src/component/Page/OneTrustScript3.jsx